import { SOPDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

type Options =
  | {
      alarmId: string;
    }
  | {
      locationId: string;
      alarmTypeId?: string;
    };

export function useSOP(
  opt: Options,
  onSuccess?: (data: SOPDTO) => void,
  enabled = true
) {
  const search = new URLSearchParams();

  if ('alarmId' in opt) {
    search.set('alarm_id', opt.alarmId);
  } else {
    search.set('location_id', opt.locationId);
    // Only include alarm_type_id if it has a value
    if (opt.alarmTypeId) {
      search.set('alarm_type_id', opt.alarmTypeId);
    }
  }

  const url = `/v2/orm/sop/find?${search.toString()}`;
  const request = new Request(url);

  return useAuthenticatedRequest<SOPDTO>(request, {
    queryKey: ['sop', opt],
    enabled,
    responseModifier: async (response) => {
      const respJson = await response.json();
      const sopResp = respJson.payload;

      try {
        const sopObj = JSON.parse(sopResp.sop_text);
        return {
          sop_workflow: sopObj.sop_workflow,
          id: sopResp.id,
          scan_sop: sopObj.scan_sop,
          alarm_type_id: sopResp.alarm_type_id,
          map_embed_url: sopResp.map_embed_url,
          updated_at_utc: sopResp.updated_at_utc,
        };
      } catch (error) {
        return {
          sop_text: sopResp.sop_text,
          id: sopResp.id,
          alarm_type_id: sopResp.alarm_type_id,
          updated_at_utc: sopResp.updated_at_utc,
        };
      }
    },
    onSuccess,
  });
}

export default useSOP;
